<div
  class="flex flex-wrap justify-evenly gap-5 px-[30px] py-5 max-md:px-4"
>
  @if ((browserSize$ | async) !== 'small') {
    <app-totals-display
      class="flex-1 self-center"
      [activeLocations]="(totalActiveLocations$ | async) || 0"
      [activeOrders]="(activeOrders$ | async)?.length || 0"
    ></app-totals-display>
  }

  <app-active-order-chart
    class="flex-1 self-center"
    [data]="orderResCurr"
    [total]="40"
    [order]="activeOrders$ | async"
    [loading]="false"
  ></app-active-order-chart>
</div>
